/**
 * @generated SignedSource<<07150419ad7a7e56e5e737facfddd3a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ComplexMenuDesktopMainNavigation_platform",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "centerMainMenu",
      "storageKey": null
    }
  ],
  "type": "Platform",
  "abstractKey": null
};

node.hash = "1f68b5971751aee3712e4b25c5cbefa2";

module.exports = node;
